import { render, staticRenderFns } from "./productsTable.vue?vue&type=template&id=71e10c3c&"
import script from "./productsTable.vue?vue&type=script&lang=js&"
export * from "./productsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports